import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useSwiperSlide } from 'swiper/react';
import { enhancedConnect } from "../../../utils";
import { _Lottie as Lottie } from "../../Lottie";
var _CarouselSlideLottie = function _CarouselSlideLottie(props) {
  var lottieRef = React.useRef(null);
  var _useSwiperSlide = useSwiperSlide(),
    isActive = _useSwiperSlide.isActive;
  React.useEffect(function () {
    var _lottieRef$current;
    (_lottieRef$current = lottieRef.current) === null || _lottieRef$current === void 0 ? void 0 : _lottieRef$current.stop();
    // нужно выбить из основного стэка, иначе не стартует, когда вьюпорт прямо на блоке после старта страницы
    if (isActive) {
      setTimeout(function () {
        var _lottieRef$current2;
        (_lottieRef$current2 = lottieRef.current) === null || _lottieRef$current2 === void 0 ? void 0 : _lottieRef$current2.play();
      }, 100);
    }
  }, [isActive]);
  return /*#__PURE__*/React.createElement(Lottie, _extends({
    autoPlay: false,
    loop: false
  }, props, {
    lottieRef: lottieRef,
    "data-t-id": "Carousel-CarouselSlideLottie"
  }));
};
export var CarouselSlideLottie = enhancedConnect()(_CarouselSlideLottie);